import { primaryColor } from '~/colors'

export default {
    container: {
        marginBottom: 30,
        cursor: 'pointer'
    },
    productName: {
        color: primaryColor,
        fontWeight: 'bold',
        marginBottom: 4
    },
    productDescription: {
        height: 17,
        maxWidth: 600,
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap'
    },
    productLinkActive: {
        color: primaryColor
    }
}



// WEBPACK FOOTER //
// ./src/views/Search/SearchResult/styles.js